import React from 'react';
import { Link } from 'react-router-dom';

interface CustomProps {
  itemPosition?: number;
  route?: string;
  defaultValue?: string;
  value?: string | number | any[] | any;
  separationChar?: string;
  noLink?: boolean;
  record?:any;
  source?:any
}
const Component: React.SFC<CustomProps> = (props) => {
  const { route, record, defaultValue ,source} = props;
  let { value } = props;

  if (Array.isArray(props.value)) {
    for (let x = 0; x < value.length; x += 1) {
      value[x] = value[x].charAt(0).toUpperCase() + value[x].substr(1);
    }
    return value.join(` ${props.separationChar ? props.separationChar : '|'} `);
  }
  if (typeof value === 'string') {
    value = value.charAt(0).toUpperCase() + value.substr(1);
  }
  if (!value && defaultValue) {
    value = defaultValue;
  }

  return props.source === "intialRating" ? (
  <div className="CrudTextField" style={{width:"50%"}}> 
    <div style={{display:"flex"}}>
      <span style={{
        fontSize:16,
        fontWeight:"bold"
      }}>{value} </span>
      </div>
      </div>
  ) : (
    <div className="CrudTextField" style={{width:"50%"}}> 
    <div style={{display:"flex"}}>
      <span style={{
        fontSize:16,
        fontWeight:"bold"
      }}>{record.developmentOutComes} </span> -
       {record.developmentOutComes === 1 ?
         <span style={{
         
          backgroundColor: "red",
          color: "white",
          borderRadius: 10,
          marginLeft: 10,
          width:"100%",
           textAlign:"center",
   
         }}>Below Avarege</span>
        : record.developmentOutComes === 2 ?<span style={{
         
          backgroundColor: "rgb(217, 165, 9)",
          color: "white",
          borderRadius: 10,
          marginLeft: 10,
           width:"100%",
            textAlign:"center",
  
         }}>Avarege</span>
        :record.developmentOutComes === 3 ? <span style={{
         
          backgroundColor: "green",
          color: "white",
          borderRadius: 10,
          marginLeft: 10,
           width:"100%",
            textAlign:"center",
         
         }}>Good</span>
        :<span style={{
         
          backgroundColor: "teal",
          color: "white",
          borderRadius: 10,
          marginLeft: 10,
           width:"100%",
           textAlign:"center",
  
         }}>Outstandings</span>
      }
    </div>
   </div> 

  );
};

Component.defaultProps = {
  itemPosition: 1,
};

export default Component;
